// extracted by mini-css-extract-plugin
module.exports = {"root":"_2fRcBFo_TtsLEA2HzIEkDn","input":"tFWlulDXYHI9RDDfHArVw","checkbox":"_3ozUnz_xxXBdSdW5-Hv0Dd","disabled":"_1LwvVlkmWKdFLm7NkdKduj","label":"_3ahfq-ilZleknC8bU3k3Tb"};